import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { UserContext } from './context/UserContextProvider';
import Clock from './pages/tools/Clock';
import './Header.css'; // Assuming you have a CSS file for additional styles

const Header = () => {
  const location = useLocation();
  const { logoutUser, isLoggedIn, currentStep, clientUrlRoot, testUnderway, isLeapFrogTest, isSampleTest, accessCode, getApiConfig, switchTest, allTimeoutsAllowed, ttGroup } = useContext(UserContext);
  // Detect if this is the VA login page based on query parameter
  const queryParams = new URLSearchParams(location.search);
  const isValoginPage = queryParams.has('valogin');
  // Detect VA login or landing pages (unprotected VA pages use 'valanding')
  const isVALandingPage = location.pathname === '/valanding' || queryParams.has('valanding');
  // Show VA navigation items when user is logged in or on VA-specific pages when logged out
  const showVAitems = isLoggedIn || isValoginPage || isVALandingPage;
  // Use VA color scheme when in VA context (VA users or VA-specific pages)
  const isVAContext = (isLoggedIn && ttGroup === 'VA') || (!isLoggedIn && (isValoginPage || isVALandingPage));
  // Brand text varies for VA context vs. others
  const brandText = isVAContext ? 'EHR/CPOE Tool' : 'EHR/CPOE Evaluation Tool';
  console.log("isLeapFrogTest:", isLeapFrogTest);

  const [tests, setTests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleLogout = () => {
    logoutUser();
  };

  useEffect(() => {
    console.log("headUE1");
    const fetchTests = async () => {
      try {
        const response = await fetch(getApiConfig('getActiveTestsBySiteAccessCode'), {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            'access-code': accessCode,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setTests(data);
      } catch (error) {
        console.error('Error fetching tests:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (accessCode) {
      fetchTests();
    }
  }, [accessCode, getApiConfig]);

  const extractDisplayName = (rawName) => {
    const regex = /^[a-zA-Z]+\s\d+\s(.*?)\sTemplate/;
    const match = rawName.match(regex);
    return match ? match[1] : rawName;
  };

  const handleSelect = (eventKey) => {
    switchTest(eventKey);
  };

  return (
      <>
        <Navbar collapseOnSelect expand={isVAContext ? "lg" : "md"} variant="ccts" className={isVAContext ? 'navbar-va' : ''}>
          {/* Conditionally link brand, disable on VA login page when logged out */}
          {((!isValoginPage && !isVALandingPage) || isLoggedIn) ? (
            <LinkContainer to={isSampleTest !== true ? "/dashboard" : currentStep}>
              <Navbar.Brand href="/">
                {/* Logo: VA when logged in to VA or on VA-specific pages when logged out; else University of Utah */}
                {((isLoggedIn && ttGroup === 'VA') || (!isLoggedIn && (isValoginPage || isVALandingPage))) ? (
                  <img
                    src="/va_ips_logo.png"
                    height="40"
                    className="d-inline-block align-top"
                    alt="VA IPS Logo"
                    style={{ marginRight: '10px', marginTop: '-5px', marginBottom: '-5px' }}
                  />
                ) : (
                  <img
                    src="/UlogoHv1_RGB_40x142.jpeg"
                    height="40"
                    width="142"
                    className="d-inline-block align-top"
                    alt="University of Utah"
                    style={{ marginRight: '10px', marginTop: '-5px', marginBottom: '-5px' }}
                  />
                )}
                {brandText}
              </Navbar.Brand>
            </LinkContainer>
          ) : (
            <Navbar.Brand as="span">
              {/* Logo: VA when logged in to VA or on VA-specific pages when logged out; else University of Utah */}
              {((isLoggedIn && ttGroup === 'VA') || (!isLoggedIn && (isValoginPage || isVALandingPage))) ? (
                <img
                  src="/va_ips_logo.png"
                  height="40"
                  className="d-inline-block align-top"
                  alt="VA IPS Logo"
                  style={{ marginRight: '10px', marginTop: '-5px', marginBottom: '-5px' }}
                />
              ) : (
                <img
                  src="/UlogoHv1_RGB_40x142.jpeg"
                  height="40"
                  width="142"
                  className="d-inline-block align-top"
                  alt="University of Utah"
                  style={{ marginRight: '10px', marginTop: '-5px', marginBottom: '-5px' }}
                />
              )}
              {brandText}
            </Navbar.Brand>
          )}
          <Navbar.Toggle />
          <Navbar.Collapse variant="light">
            <Nav className="mr-auto custom-nav">
              {/* Show disabled VA nav items on VA-specific pages when logged out */}
              {/* Disabled VA nav items on VA-specific pages when logged out */}
              {!isLoggedIn && (isValoginPage || isVALandingPage) && (
                <>
                  <Nav.Link disabled>{isVAContext ? 'Home Page' : 'Dashboard'}</Nav.Link>
                  <NavDropdown title="Available Tests" id="basic-nav-dropdown" className="custom-dropdown" disabled>
                    <NavDropdown.Item>No tests available</NavDropdown.Item>
                  </NavDropdown>
                  <Nav.Link disabled>Instructions</Nav.Link>
                  <Nav.Link disabled>Current Step</Nav.Link>
                  <Nav.Link disabled>Improvement</Nav.Link>
                </>
              )}
              {isLoggedIn && isVAContext && (
                <>
                  {isSampleTest !== true && (
                    <LinkContainer to="/dashboard">
                      <Nav.Link>Home Page</Nav.Link>
                    </LinkContainer>
                  )}
                  {(() => {
                    // We'll check each piece of the condition and log a message if it fails.
                    if (!isLoggedIn) {
                      console.log("Available Tests dropdown hidden because: user is NOT logged in.");
                      return null;
                    }
                    if (isLeapFrogTest) {
                      console.log("Available Tests dropdown hidden because: this is a LeapFrog test.");
                      return null;
                    }
                    if (testUnderway === true) {
                      console.log("Available Tests dropdown hidden because: a test is currently underway.");
                      return null;
                    }
                    if (isSampleTest === true) {
                      console.log("Available Tests dropdown hidden because: this is a sample test.");
                      return null;
                    }
                    // Hide on certain pages; for VA context show disabled dropdown
                    const hiddenPaths = ['/viewresults', '/viewhistoricalresults', '/instructionspdf', '/improvement'];
                    if (hiddenPaths.includes(location.pathname)) {
                      console.log("Available Tests dropdown hidden because: current location pathname is in hiddenPaths.");
                      return (
                        <NavDropdown
                          title="Available Tests"
                          id="basic-nav-dropdown"
                          className="custom-dropdown"
                          disabled
                        >
                          <NavDropdown.Item>No tests available</NavDropdown.Item>
                        </NavDropdown>
                      );
                    }
                    // If all conditions pass, render the dropdown:
                    return (
                      <NavDropdown
                        title="Available Tests"
                        id="basic-nav-dropdown"
                        className="custom-dropdown"
                        onSelect={handleSelect}
                        disabled={isLoading || tests.length === 0}
                      >
                        {tests.length === 0 ? (
                          <NavDropdown.Item>No tests available</NavDropdown.Item>
                        ) : (
                          tests.map((test) => (
                            <NavDropdown.Item
                              key={test.access_code}
                              eventKey={test.access_code}
                              active={test.access_code === accessCode}
                              onClick={(e) => {
                                if (test.access_code === accessCode) {
                                  e.preventDefault();
                                } else {
                                  switchTest(test.access_code);
                                }
                              }}
                            >
                              {extractDisplayName(test.test_name)}
                              {test.role_display_name && ` (${test.role_display_name})`}
                            </NavDropdown.Item>
                          ))
                        )}
                      </NavDropdown>
                    );
                  })()}
                  {isSampleTest !== true && (
                    <LinkContainer to="/instructionspdf">
                      <Nav.Link>Instructions</Nav.Link>
                    </LinkContainer>
                  )}
                  {!isLeapFrogTest && (
                    <LinkContainer to={currentStep}>
                      <Nav.Link>Current Step</Nav.Link>
                    </LinkContainer>
                  )}
                  <LinkContainer to="/improvement">
                    <Nav.Link>Improvement</Nav.Link>
                  </LinkContainer>
                </>
              )}
{!isVAContext && isLoggedIn && isSampleTest !== true && <LinkContainer to="/dashboard"><Nav.Link>{isVAContext ? 'Home Page' : 'Dashboard'}</Nav.Link></LinkContainer>}
{!isVAContext && isLoggedIn && isSampleTest !== true && <LinkContainer to="/instructionspdf"><Nav.Link>Instructions</Nav.Link></LinkContainer>}
{!isVAContext && isLoggedIn && isVAContext && <LinkContainer to="/improvement"><Nav.Link>Improvement</Nav.Link></LinkContainer>}
{!isVAContext && isLoggedIn && !isLeapFrogTest && <LinkContainer to={currentStep}><Nav.Link>Current Step</Nav.Link></LinkContainer>}
              {isLoggedIn && isLeapFrogTest && !testUnderway && !isSampleTest ? (
                  <LinkContainer to="/sampledashboard"><Nav.Link>Take Sample Test</Nav.Link></LinkContainer>
              ) : ""
              }
              {isLeapFrogTest && <a className="nav-link" href="https://leapfroghelpdesk.zendesk.com/" target="_blank" rel="noopener noreferrer">Contact the Leapfrog Help Desk</a>}
{!isVAContext && (() => {
                // We'll check each piece of the condition and log a message if it fails.
                if (!isLoggedIn) {
                  console.log("Available Tests dropdown hidden because: user is NOT logged in.");
                  return null;
                }
                if (isLeapFrogTest) {
                  console.log("Available Tests dropdown hidden because: this is a LeapFrog test.");
                  return null;
                }
                if (testUnderway === true) {
                  console.log("Available Tests dropdown hidden because: a test is currently underway.");
                  return null;
                }
                if (isSampleTest === true) {
                  console.log("Available Tests dropdown hidden because: this is a sample test.");
                  return null;
                }
                // Hide on certain pages; for VA context show disabled dropdown
                const hiddenPaths = ['/viewresults', '/viewhistoricalresults', '/instructionspdf', '/improvement'];
                if (hiddenPaths.includes(location.pathname)) {
                  console.log("Available Tests dropdown hidden because: current location pathname is in hiddenPaths.");
                  if (isVAContext) {
                    return (
                      <NavDropdown
                        title="Available Tests"
                        id="basic-nav-dropdown"
                        className="custom-dropdown"
                        disabled
                      >
                        <NavDropdown.Item>No tests available</NavDropdown.Item>
                      </NavDropdown>
                    );
                  }
                  return null;
                }

                // If all conditions pass, render the dropdown:
                return (
                    <NavDropdown
                        title="Available Tests"
                        id="basic-nav-dropdown"
                        className="custom-dropdown"
                        onSelect={handleSelect}
                        disabled={isLoading || tests.length === 0}
                    >
                      {tests.length === 0 ? (
                          <NavDropdown.Item>No tests available</NavDropdown.Item>
                      ) : (
                          tests.map((test) => (
                              <NavDropdown.Item
                                  key={test.access_code}
                                  eventKey={test.access_code}
                                  active={test.access_code === accessCode}
                                  onClick={(e) => {
                                    if (test.access_code === accessCode) {
                                      e.preventDefault(); // Prevent action if it's the current test
                                    } else {
                                      switchTest(test.access_code);
                                    }
                                  }}
                              >
                                {extractDisplayName(test.test_name)}
                                {test.role_display_name && ` (${test.role_display_name})`}
                              </NavDropdown.Item>
                          ))
                      )}
                    </NavDropdown>
                );
              })()}


            </Nav>
            <Nav className="ml-auto">
              {isLoggedIn && testUnderway && !isSampleTest && allTimeoutsAllowed ? <Clock /> : ''}
              {isLeapFrogTest ? '' : isLoggedIn ? (
                  /* Only VA currently sees the logout button; send VA users back to the VA login page */
                  <LinkContainer to="/?valogin"><Button onClick={handleLogout} className="px-3" variant="outline-light">Logout</Button></LinkContainer>
              ) : (
                  <Nav.Link href="mailto:Helpdesk_EHRSafetyEvalTool@utah.edu?subject=EHR Safety Eval Tool&body=Hello, I need some help with...">Need Assistance? Contact Info</Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </>
  );
};

export default Header;
